import { render } from "./TheHomeComponent.vue?vue&type=template&id=20901817&scoped=true"
import script from "./TheHomeComponent.vue?vue&type=script&lang=js"
export * from "./TheHomeComponent.vue?vue&type=script&lang=js"

import "./TheHomeComponent.vue?vue&type=style&index=0&id=20901817&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20901817"]])

export default __exports__